<template>
	<div
		class="columns is-centered is-vcentered is-multiline product-review pb-3 pt-1">
		<div class="column is-narrow has-text-centered pb-6 pt-2">
			<div class="has-text-warning">
				<p>
					<span class="is-size-1 has-text-weight-bold">{{
						summary.average
					}}</span>
				</p>
				<p>
					<star-rating-input
						ref="starRating"
						:rating_prop="summary.average"
						:mode_prop="'estimate'"
						:text_size_prop="4"></star-rating-input>
				</p>
				<button
					@click="toggleReviewInput"
					class="button is-warning is-medium has-text-warning-dark mt-4">
					Write a Review
				</button>
			</div>
		</div>
		<div class="column is-offset-1 is-5">
			<div class="columns is-multiline">
				<div
					v-for="(count, rating) in summary.rating_breakdown"
					class="column is-full">
					<div class="columns is-vcentered">
						<div class="column pt-0 pb-1 pr-0 is-narrow has-text-warning">
							<span class="has-text-weight-bold is-size-5">{{
								rating
							}}</span
							>&nbsp;&nbsp;<span
								class="is-relative"
								style="bottom: 0.1rem"
								><i class="fas fa-star"></i
							></span>
						</div>
						<div class="column pt-0 pb-1">
							<div class="columns is-vcentered p-0 m-0">
								<div class="column is-10 p-1 m-0">
									<progress
										class="progress is-warning is-small has-background-warning-light"
										:value="count"
										:max="summary.rating_count">
										{{ 100 * ratingValue(count) }}%
									</progress>
								</div>
								<div
									class="column is-2 m-0 p-1 has-text-warning has-text-weight-bold"
									style="text-shadow: 0 0 3px antiquewhite">
									<span
										>{{
											(100 * ratingValue(count)).toFixed(1)
										}}%</span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
	.product-review {
		/*
        border: solid 1px #DCDCDC;
        border-radius: 7px;
        */
	}
</style>
<script>
	import StarRatingInput from "./StarRatingInput.vue";
	export default {
		components: { StarRatingInput },
		props: {
			summary_prop: Object,
		},
		emits: ["toggle-review-input"],
		data() {
			return {};
		},
		computed: {
			summary() {
				if (typeof this.$props.summary_prop != "undefined") {
					return this.$props.summary_prop;
				}
				return {};
			},
		},
		methods: {
			toggleReviewInput() {
				this.$emit("toggle-review-input");
			},
			ratingValue(rating) {
				let divisor = this.summary.rating_count;
				if (divisor == 0) {
					divisor = 1;
				}
				return rating / divisor;
			},
		},
	};
</script>
